var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./AdditionalKits.js"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-38981ae2!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AdditionalKits.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Users/Payment/AdditionalKits.vue
// module id = 671
// module chunks = 0